<template>
    <div>
      <div class="comment-star">
        <div class="star-sku">
          <img src="../assets/image/plp.png">
        </div>
        <div class="star-evaluate">
          <p>描述相符</p>
          <div>
            <img src="../assets/image/comment-star.png">
            <img src="../assets/image/comment-star.png">
            <img src="../assets/image/comment-star.png">
            <img src="../assets/image/comment-star.png">
            <img src="../assets/image/comment-star2.png">
          </div>
        </div>
      </div>
      <div class="comment-msg">
        <textarea>产品满足您的期待吗?说说您的使用心得,分享给想买的他们吧
        </textarea>
      </div>
      <div class="comment-img">
        <img src="../assets/image/plp.png">
        <img src="../assets/image/plp.png">
        <div class="c-add">
          <img src="../assets/image/camera.png">
          <p>添加图片</p>
        </div>
      </div>
      <div class="comment-commit">提交</div>
      <div class="comment-popup">
        <div class="pop-bg">
          <p class="pop-title">确认发布我的评论</p>
          <div class="pop-btn">
            <div class="pop-cancel">取消</div>
            <div class="pop-ensure">确认</div>
          </div>
        </div>
      </div>
    </div>
</template>
<style scoped lang="less">
  .comment-star {
       display: flex;
       align-items: flex-start;
       padding: 13px 18px;
       background-color: #ffffff;
       .star-sku {
         width: 43px;
         height: 43px;
         border: 1px solid #9f9f9f;
         img {
           width: 80%;
         }
       }
       .star-evaluate {
         font-size: 11px;
         color: #585858;
         margin-left: 15px;
         img {
           width: 18px;
           margin: 10px 26px 0 0;
         }
       }
     }
  .comment-msg {
    padding: 18px;
    textarea {
      width: 100%;
      min-height: 80px;
      font-size: 11px;
      color: #999999;
      background-color: transparent;
      border: none;
      outline: none;
    }
  }
  .comment-img {
    padding: 25px 18px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    background-color: #ffffff;
    &>img {
      width: 23%;
      margin-right: 2%;
      margin-bottom: 15px;
    }
    .c-add {
      width: 23%;
      text-align: center;
      color: #999999;
      font-size: 11px;
      border: 1px dotted #9f9f9f;
      img {
        width: 50%;
      }
    }
  }
  .comment-commit {
    width: 70%;
    margin-left: 15%;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background-color: #318ff2;
    color: #ffffff;
    margin-top: 60px;
    font-size: 16px;
  }
  .comment-popup {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.2);
    .pop-bg {
      position: absolute;
      left: 10%;
      right: 10%;
      top: 25%;
      background-color: #ffffff;
    }
    .pop-title {
      color: #8e8e8e;
      font-size: 12px;
      margin: 65px 0 35px 0;
      text-align: center;
    }
    .pop-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 14px;
      text-align: center;
      margin-bottom: 35px;
    }
    .pop-cancel {
      width: 38%;
      height: 38px;
      line-height: 38px;
      background-color: #a1a9ae;
      margin-right: 10px;
    }
    .pop-ensure {
      width: 38%;
      height: 38px;
      line-height: 38px;
      background-color: #0d70d2;
    }
  }
</style>
<script>

    export default{
        data(){
            return{
                msg:'hello vue'
            }
        },
        components:{

        }
    }

</script>



// WEBPACK FOOTER //
// src/components/Comment.vue